import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {imageType} from '../../../utils/commonPropTypes'
import WidthContainer from '../../../components/WidthContainer'

import MaskedImage from '../../../components/MaskedImage'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import Socials from '../../../components/Socials'

const RootContainer = styled(WidthContainer)`
	max-width: ${props => props.theme.smallerWidth};
	margin-top: 3.75rem;
`

const InnerContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: -1rem;
	
	> * {
		margin: 1rem;
	}
`

const Column = styled.div`
	max-width: 16rem;
`

const Photo = styled(QueriedGatsbyImage)`
	width: 180px!important;
`

const Name = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
	font-size: ${props => props.theme.fontSizes.big20};
`

const Position = styled.div`
	margin-bottom: 1rem;
`

const Comapny = styled.div`
	margin-bottom: 1.56rem;
	font-size: ${props => props.theme.fontSizes.small};
	color: ${props => props.theme.colors.grayText};
`
const About = styled.div`
	font-size: ${props => props.theme.fontSizes.small};

`

const AuthorInfo = ({className, data}) => <RootContainer className={className}>
	<InnerContainer>
		<Column>
			<MaskedImage>
				<Photo image={data.photo}/>
			</MaskedImage>
		</Column>
		<Column>
			<Name>{data.name}</Name>
			<Position>{data.position}</Position>
			<Socials data={data.socials}/>
			<Comapny>{data.company}</Comapny>
			<About>{data.about}</About>
		</Column>
	</InnerContainer>
</RootContainer>

AuthorInfo.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		photo: imageType.isRequired,
		name: PropTypes.string.isRequired,
		position: PropTypes.string.isRequired,
		company: PropTypes.string.isRequired,
		about: PropTypes.string.isRequired,
		socials: PropTypes.shape({
			linkedin: PropTypes.string.isRequired,
			twitter: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
}

AuthorInfo.defaultProps = {
	className: '',
}

export default AuthorInfo
